import DialogInfo from '~/components/dialog/info/DialogInfo.vue';

export const useDialogErrorMessage = () => {
  const dialog = useDialogStore();

  const open = (
    title: String,
    message: string,
    onReleaseError: Function = null
  ) => {
    dialog.open(DialogInfo, {
      level: DialogLevel.Info,
      title,
      label: message,
      onConfirm: () => {
        if (onReleaseError) onReleaseError();
        dialog.close();
      },
      onClose: () => {
        if (onReleaseError) onReleaseError();
      },
    });
  };
  return {
    open,
  };
};
